//https://stackoverflow.com/questions/122102/what-is-the-most-efficient-way-to-deep-clone-an-object-in-javascript
/**
 *
 * @param obj Deep copy with parse / stringify.
 */
const deepCopy = function <T>(obj: T) {
  return JSON.parse(JSON.stringify(obj)) as T;
};
export default deepCopy;
